var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
const defaultReducerState = {
  items: getDefaultAsyncWrapperObj()
};
const actionTypesPrefix = "loadDataSourceOverrideList";
const dataSourceOverrideListActionTypes = {
  LOAD: `${actionTypesPrefix}/LOAD`,
  LOADING: `${actionTypesPrefix}/LOADING`,
  LOADED: `${actionTypesPrefix}/LOADOADED`
};
const dataSourceOverrideListLoadAction = (workspaceId, dataSourceName) => {
  return {
    type: dataSourceOverrideListActionTypes.LOAD,
    payload: { workspaceId, dataSourceName }
  };
};
const dataSourceOverrideListLoadingAction = (payload) => {
  return {
    type: dataSourceOverrideListActionTypes.LOADING,
    payload
  };
};
const dataSourceOverrideListLoadedAction = (payload, result) => {
  return {
    type: dataSourceOverrideListActionTypes.LOADED,
    payload: {
      items: result
    }
  };
};
const reducer = (state = defaultReducerState, action) => {
  switch (action.type) {
    case dataSourceOverrideListActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        items: __spreadProps(__spreadValues({}, state.items), {
          status: AsyncRequestStatus.Pending
        })
      });
    case dataSourceOverrideListActionTypes.LOADED:
      const loadedAction = action;
      return __spreadProps(__spreadValues({}, state), {
        items: loadedAction.payload.items
      });
    default:
      return state;
  }
};
export {
  dataSourceOverrideListActionTypes,
  dataSourceOverrideListLoadAction,
  dataSourceOverrideListLoadedAction,
  dataSourceOverrideListLoadingAction,
  reducer as default,
  defaultReducerState,
  reducer
};
//# sourceMappingURL=DataSourceDetailOverrideList.ducks.js.map
